import React, { createContext } from 'react'

import { serverSideQuery, useQuery } from '@/api'
import { RELATED_VENUES_ENDPOINT } from '@/constants'
import type { VenueDataType, VenuesStateType } from '@/context/venue/types'

import { venuesSelector } from './selectors'
import type { RelatedVenuesContextType, RelatedVenuesProviderProps, RelatedVenuesSelectors } from './types'

const RelatedVenuesContext = createContext<RelatedVenuesContextType>(undefined as any)
const { Provider } = RelatedVenuesContext

export const RelatedVenuesProvider: React.FC<RelatedVenuesProviderProps> = ({
    children,
    initialParams,
    initialProps,
    initialFetchDisabled,
}) => {
    const { fetching, data, error } = useQuery<VenueDataType>({
        endpoint: RELATED_VENUES_ENDPOINT,
        params: initialParams,
        initialFetchDisabled,
        initialData: initialProps?.data,
    })

    const state: VenuesStateType = { fetching, data, error }
    const selectors: RelatedVenuesSelectors = {
        venues: venuesSelector(state),
    }
    const contextValue: RelatedVenuesContextType = { state, selectors }

    return <Provider value={contextValue}>{children}</Provider>
}

export const serverSideRead = serverSideQuery<VenueDataType>(RELATED_VENUES_ENDPOINT)

export default RelatedVenuesContext
